export default function defaultTranslateFunction(str) {
    return str;
}
//# sourceMappingURL=default-translate-function.js.map